/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import { createApp } from "vue"; // Vue 3 import
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

// Add the necessary CSS
import BootstrapPlugin from "./plugins/bootstrap-vue"
import '@/assets/css/style.css'
import "@/assets/css/font-awesome.min.css";
import "@/assets/css/montserrat-font.css";
import "@/assets/css/muli-font.css";

import PaperDashboard from "./plugins/paperDashboard";

import NotifyPlugin from './plugins/notify'

import "leaflet/dist/leaflet.css";
import Keycloak from 'keycloak-js';
import { profilIcpeService } from "@/service/profilIcpe.service.js";
import { mapService } from "@/service/map.service.js";
import Card from "@/components/Cards/Card.vue";
import {useFilters} from "@/composables/useFilters";
import { env } from "./env";

// Création de l'application Vue 3
const app = createApp(App);

// Intégration du plugin PaperDashboard
app.use(PaperDashboard);

//Filters
// Ajouter les filtres comme propriétés globales
app.config.globalProperties.$filters = useFilters();


// Mixins globale : le concept de mixin existe toujours en Vue 3, on peut les enregistrer globalement ainsi :
app.mixin({
  methods: {
    getLibelleEtat(parc) {
      switch (parc.statutSaisie.libelle) {
        case "Brouillon":
          return "Saisie en cours";
        default:
          return "Données publiées";
      }
    },
    getClasseStatut(parc) {
      switch (parc.statutParc.libelle) {
        case "Refusé":
          return "danger";
        case "Rejeté":
          return "danger";
        case "En instruction":
          return "warning";
      }

      switch (parc.etatParc.libelle) {
        case "En exploitation":
          return "success";
        case "En démantèlement":
          return "info";
        case "En attente de construction":
          return "warning";
        case "En construction":
          return "warning";
        default:
          return "dark";
      }
    }
  }
});

// Initialisation des projections
mapService.initProjections();

const propertiesUrl = new URL(`${env.apiUrl}/properties`);
fetch(propertiesUrl, { method: 'GET' }).then(async res => {
  const properties = await res.json();
  Object.assign(env, properties);

  const initOptions = {
    url: properties.keycloak.authUrl,
    realm: properties.keycloak.realm,
    clientId: properties.keycloak.clientId
  };

  // Renvoi vers le login cerber
  const keycloak = new Keycloak(initOptions);
  keycloak
    .init({
      onLoad: 'login-required',
      checkLoginIframe: false
    })
    .then((authenticated) => {
      if (!authenticated) {
        console.log("Vous n'êtes pas authentifié");
      } else {
        // Sauvegarde du jeton
        store.dispatch("saveToken", keycloak.token);

        // Récupération des droits
        profilIcpeService
          .getProfilIcpe()
          .then(profilIcpe => {
            const idApplicationIndex = profilIcpe
              ? profilIcpe.droits.findIndex(droit => droit.id_application == properties.keycloak.applicationId)
              : null;

            if (idApplicationIndex == -1) {
              // Redirection vers la page de création de compte Cerbère
              window.location.replace(properties.monaiotCreationCompteUrl);
            }

            // Sauvegarder l'utilisateur
            store.dispatch("saveUser", profilIcpe);

            // Montage de l'application une fois l'utilisateur récupéré
            app.use(router);
            app.use(store);
            app.component('Card', Card) // Enregistrement global du composant
            app.use(BootstrapPlugin);
            app.use(NotifyPlugin);
            app.mount("#app");

          })
          .catch(err => console.log(err));
      }
    })
    .catch(() => {
      alert("Failed to initialize Keycloak");
    });
}).catch(err => console.log("Failed to fetch frontend properties", err));

